import { render, staticRenderFns } from "./addAServMenu.vue?vue&type=template&id=07650082"
import script from "./addAServMenu.vue?vue&type=script&lang=js"
export * from "./addAServMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports